import { AbstractControl, ValidatorFn } from '@angular/forms';



export class NoWhitespaceValidator {


  public static noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      let isWhitespace = (control.value || '').trim().length === 0;
      let isValid = !isWhitespace;
      return isValid ? null : { 'whitespace': 'value is only whitespace' }
    };

  }

}